import { GET_MY_GRADES_SUCCESS } from "../constants";

export const initialState = {
  myGrades: undefined,
};
export const MyGradesReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_MY_GRADES_SUCCESS: {
      return {
        ...state,
        myGrades: action.payload,
      };
    }

    default:
      return state;
  }
};
